import React, { Fragment, } from 'react';
import { Route, Routes } from 'react-router-dom';
import { routes } from './Routes';
import Layout from '../Layout/Layout';
import ErrorPage1 from 'Component/Pages/ErrorPages/error-page1';

const LayoutRoutes = () => {
  return (
    <Fragment>
      <Routes>
        {routes.map(({ path, Component }, i) => (
          <Route element={<Layout />} key={i}>
            <Route path={path} element={Component} />
          </Route>
        ))}
        <Route element={<Layout />}>
          <Route path="*" element={<ErrorPage1 />} />
        </Route>
      </Routes>
    </Fragment >
  );
};

export default LayoutRoutes;